<template>
  <transition name="snack">
    <div
      v-if="snackState.visible"
      class="snackbar"
      :data-variant="snackState.variant"
      role="status"
      aria-live="polite"
    >
      <span class="snackbar__message">{{ snackState.message }}</span>
      <button
        type="button"
        class="snackbar__close"
        :aria-label="$t('common.dismiss')"
        @click="hideSnack"
      >
        ×
      </button>
    </div>
  </transition>
</template>

<script>
import { snackState, hideSnack } from "../stores/snackbarStore";

export default {
  name: "AppSnackbar",
  data() {
    return { snackState };
  },
  methods: { hideSnack },
};
</script>

<style scoped>
.snackbar {
  position: fixed;
  left: 50%;
  bottom: 26px;
  transform: translateX(-50%);
  z-index: 1500;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  max-width: min(560px, calc(100% - 36px));
  padding: 12px 14px 12px 18px;
  border-radius: 14px;
  border: 1px solid var(--app-border);
  background: var(--app-surface-strong);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.snackbar[data-variant="success"] {
  border-color: color-mix(in srgb, var(--app-accent) 40%, transparent);
}

.snackbar[data-variant="error"] {
  border-color: color-mix(in srgb, #ef4444 50%, transparent);
  color: #b91c1c;
}

.snackbar__message {
  flex: 1;
  line-height: 1.4;
}

.snackbar__close {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.6;
}

.snackbar__close:hover {
  opacity: 1;
}

.snack-enter-active,
.snack-leave-active {
  transition: opacity 0.18s ease, transform 0.22s ease;
}

.snack-enter-from,
.snack-leave-to {
  opacity: 0;
  transform: translate(-50%, 14px);
}

.snack-enter-to,
.snack-leave-from {
  opacity: 1;
  transform: translate(-50%, 0);
}
</style>
